import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonProgressBar,
  IonRouterOutlet,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import React from "react";
import { Redirect, Route, useHistory, useLocation } from "react-router-dom";

// Import all components for each step
import GolfIcon from "@/components/GolfIcon";
import AvatarSetup from "@/components/welcome/AvatarSetup";
import GenderSelection from "@/components/welcome/GenderSelection";
import HandicapSelection from "@/components/welcome/HandicapSelection";
import MembershipSelection from "@/components/welcome/MembershipSelection";
import ProfileSetup from "@/components/welcome/ProfileSetup";
import RoleSelection from "@/components/welcome/RoleSelection";
import UsernameSelection from "@/components/welcome/Username";
import { signOut } from "@/utils/capacitorUtils";

const Welcome: React.FC = () => {
  document.title = "CapGolf - Onboarding";

  const steps = [
    { path: "/welcome/role", component: RoleSelection, skip: false },
    { path: "/welcome/gender", component: GenderSelection, skip: true },
    { path: "/welcome/handicap", component: HandicapSelection, skip: true },
    { path: "/welcome/profile-details", component: ProfileSetup, skip: false },
    { path: "/welcome/avatar", component: AvatarSetup, skip: true },
    { path: "/welcome/membership", component: MembershipSelection, skip: true },
    { path: "/welcome/username", component: UsernameSelection, skip: false },
  ];

  const location = useLocation();
  const history = useHistory();

  // Si nous sommes exactement sur /welcome, rediriger directement vers la première étape
  if (location.pathname === '/welcome') {
    return <Redirect to={steps[0].path} />;
  }

  // Calculer l'étape actuelle pour la barre de progression
  const currentStepIndex = steps.findIndex((step) => step.path === location.pathname);
  const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1; // Index starts from 0, so add 1 for display

  return (
    <IonPage>
      <IonHeader className="ion-no-border bg-card">
        <IonToolbar>
          <IonButtons slot="start">
            {!location.pathname.includes(steps[0].path) && <IonBackButton className="text-foreground" text="" defaultHref={steps[currentStep - 1].path}></IonBackButton>}
          </IonButtons>
          <IonButtons slot="end">
            <IonButton onClick={async (event) => {
              event.preventDefault()
              await signOut();
              history.push('/')
            }}>
              <GolfIcon name="close" className="size-5" />
            </IonButton>
          </IonButtons>
          <IonTitle><IonProgressBar className="h-3" value={(currentStep - 1) / (steps.length - 1)}></IonProgressBar></IonTitle>
        </IonToolbar>
      </IonHeader >

      <IonContent scrollY={false}>
        <IonRouterOutlet>
          {/* Définir les routes pour chaque étape */}
          {steps.map((step, index) => (
            <Route
              key={step.path}
              exact
              path={step.path}
              render={() => (
                <step.component
                  nextStep={steps[index + 1]?.path}
                />
              )}
            />
          ))}
        </IonRouterOutlet>
      </IonContent>
    </IonPage >
  );
};

export default Welcome;